import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../utils/api';

export function useReportReasons({ enabled = true } = {}) {
    const [reasons, setReasons] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const loadReasons = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await apiClient.getReportReasons();
            setReasons(Array.isArray(data) ? data : []);
            return data;
        } catch (err) {
            const message = err?.message || 'Failed to load report reasons.';
            setError(message);
            setReasons([]);
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!enabled) {
            return;
        }
        loadReasons().catch(() => {
            // error state handled via setError
        });
    }, [enabled, loadReasons]);

    return {
        reasons,
        loading,
        error,
        refresh: loadReasons,
    };
}
